export default function initAddToCart(): void {
  Alpine.data('addToCart', () => ({
    submitting: false,

    async handleSubmit(event: SubmitEvent) {
      event.preventDefault();
      const form = event.target as HTMLFormElement;
      this.submitting = true;

      const formData = new FormData(form);

      const response = await fetch('', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });
      const result = await response.json();
      window.dispatchEvent(new CustomEvent('carttoast', {
        detail: {
          success: result.success,
          message: result.success ? Craft.t('js', 'Product added to the cart') : result.error,
        },
      }));
    },
  }));
}
